import React, { useState } from "react";
import "./MerchantPicker.scss";
import Merchant from "domain/merchant";
import { Dropdown, FormControl } from "react-bootstrap";
import NavbarMenuToggle from "common/ui/NavbarMenuToggle";
import { useDispatch } from "react-redux";
import { changeActiveMerchant } from "./login.action";
import useLocalStorageValue from "common/useLocalStorageValue";
import containsText from "common/search";


interface MerchantPickerProps {
    merchants: Merchant[];
    activeMerchant: Merchant;
}

const mruSize = 5;

const MerchantPicker: React.FC<MerchantPickerProps> = (props: MerchantPickerProps) => {
    const [searchText, setSearchText] = useState<string>("");
    const dispatch = useDispatch();

    const mruList = useLocalStorageValue<string[]>("MerchantPicker_MostRecentlyUsed", []);

    const isSearching = searchText.length > 0;

    let mruMerchants: Merchant[], remainingMerchants: Merchant[];

    if (isSearching) {
        mruMerchants = [];
        remainingMerchants = props.merchants.filter(m => containsText(m.name, searchText));
    }
    else {
        mruMerchants = mruList.value.slice(1).map(m => props.merchants.find(x => x.id === m)).filter(m => m != null);
        remainingMerchants = props.merchants.filter(m => !mruList.value.includes(m.id));
    }

    function onToggle(show: boolean) {
        if (!show) {
            setSearchText("");
        }
    }

    function onSelect(merchant: Merchant) {
        const newList = [merchant.id, ...mruList.value.filter(m => m !== merchant.id)]
        mruList.setValue(newList.slice(0, mruSize + 1))
        changeActiveMerchant(dispatch, merchant);
    }

    if (props.merchants.length === 0) return <></>;

    return <Dropdown className="merchant-picker" onToggle={onToggle} data-testid="merchant-picker-icon">
        <Dropdown.Toggle as={NavbarMenuToggle} id="merchant-toggle" showArrow >
            {props.activeMerchant.name}
        </Dropdown.Toggle>
        <Dropdown.Menu>
            <Dropdown.Header>
                <FormControl
                    type="text"
                    autoFocus
                    placeholder="Search..."
                    value={searchText}
                    onChange={ev => setSearchText(ev.target.value)}
                    data-testid="merchant-search-input" />
            </Dropdown.Header>
            {
                mruMerchants.length > 0 && <>
                    <Dropdown.Header >Recent</Dropdown.Header>
                    {mruMerchants.map(m => <MerchantItem key={m.id} name={m.name} onClick={() => onSelect(m)} />)}
                    <Dropdown.Divider />
                </>
            }
            {isSearching && <Dropdown.Header>Search results</Dropdown.Header>}
            {remainingMerchants.filter(m => m.id !== props.activeMerchant.id)
                .map(m => <MerchantItem key={m.id} name={m.name} onClick={() => onSelect(m)} />)}
        </Dropdown.Menu>
    </Dropdown>;
}

interface MerchantItemProps {
    name: string;
    onClick(): void;
}

const MerchantItem: React.FC<MerchantItemProps> = React.memo(props => {
    return <Dropdown.Item onClick={props.onClick} data-testid={"merchant-" + props.name}>{props.name}</Dropdown.Item>;
})

export default MerchantPicker;